import React, {Component} from 'react'
import Hamburger from '../components/Hamburger'
import Header from '../components/Header'
import HomePage from './HomePage'
import ContactPage from './ContactPage'
import BlogPage from './BlogPage'
import ProjectsPage from './ProjectsPage'
import ProjectPage from './ProjectPage'
import {Switch, Route, Redirect} from 'react-router-dom'
import '../css/styles.css'
import WebFont from 'webfontloader'


class PrimaryLayout extends Component {
	state = {
		headerOpen: false,
		projects: [],
		posts: [],
		dataLoaded: false}

	constructor(props) {
		super(props)
		this.toggleHeader = this.toggleHeader.bind(this)
		this.hideHeader = this.hideHeader.bind(this)
	}

	componentDidMount() {
		WebFont.load({
			google: {
				families: ['Montserrat:200,500i,300', 'Open Sans:300,400', 'Playfair Display:400']
			}
		})
		fetch('../data.json')
			.then((response) => response.json())
			.then(({projects}) => {
				if (projects) {
					this.setState({...this.state, projects, dataLoaded: true})
				} else {
					throw new Error("No projects found")
				}
			})
			.catch(console.error)
		fetch('../posts.json')
			.then((response) => response.json())
			.then(({posts}) => {
				if (posts) {
					this.setState({...this.state, posts})
				} else {
					throw new Error("No posts found")
				}
			})
			.catch(console.error)
	}

	toggleHeader() {
		this.setState({...this.state, headerOpen: !this.state.headerOpen})
	}

	hideHeader() {
		this.setState({...this.state, headerOpen: false})
	}

	render() {
		const {projects,dataLoaded,posts} = this.state
		return (
			<div className="primaryLayout">
				<Hamburger isOpen={this.state.headerOpen} toggleHeader={this.toggleHeader}/>
				<Header isOpen={this.state.headerOpen}/>
				<div className="primaryLayout" onClick={this.hideHeader}>
					<Switch>
						<Route path="/" exact component={HomePage}/>
						<Route path="/contact" exact component={ContactPage}/>
						<Route path='/blog' exact render={(props) => (
							<BlogPage {...props} posts={posts}/>
						)}/>
						<Route path='/projects' exact render={(props) => (
							<ProjectsPage {...props} projects={projects}/>
						)}/>
						<Route path='/projects/:id' render={(props) => (
							<ProjectPage {...props} projects={projects} dataLoaded={dataLoaded}/>
						)}/>
						<Redirect to="/"/>
					</Switch>
				</div>

			</div>
		)
	}
}

export default PrimaryLayout


// WEBPACK FOOTER //
// ./src/containers/PrimaryLayout.js